import { ActivatedRoute, Router } from '@angular/router';
import { Injectable } from '@angular/core';


declare var $: any;

export class MenuHandler {
    

    public static menuHandler(t, id) {
        
        $("#menu_ul_id").find('li').removeClass("wiz-selected-step");
        $("#menu_ul_id").find(".wiz-num").removeClass("wiz-selected-num");

        id.toggleClass('wiz-selected-step');
        id.find(".wiz-num").toggleClass("wiz-selected-num");

        $(t).find('small.fa').remove()


        if ($(t).find('.wiz-selected-step').length == 0)
            return;
        var index = $(t).find('.wiz-selected-step').index();
        var amount = parseInt($(t).find('.wiz_group').data('wiz-steps'));
        if (amount <= 0)
            return;
        var colWidth = 100 / amount * 0.99;
        $(t).find('.wiz_group').append('<small class="fa fa-caret-down wiz-current-indiction" style="width:' + colWidth + '%; margin-right:' + (colWidth * (index)) + '%;"></small>');

        this._setWizardSteps();

        this.updateHeaderTitle();
    }

    public static _setWizardSteps() {
        var $wizGroup = $('.wiz_group');
        if (!$wizGroup || !$wizGroup.data('wiz-steps'))
            return;
        var stepsCount = parseInt($wizGroup.data('wiz-steps'));
        var $steps = $('.wiz_group>ol>li');

        if ($steps.length > 0) {
            $steps.css('width', 100 / stepsCount + '%');
            $('.wiz-current-indiction').css('width', 100 / stepsCount + '%');

            var nextStepText = $($steps[1]).find('.wiz-text').text();
            $('.next-step').attr('title', nextStepText);
        }
    }

    public static updateHeaderTitle() {
        var wiz_num = $(".wiz-selected-num");
        var wiz_text = $(".wiz-selected-num").next();

        if (wiz_num.text().length > 0 && wiz_text.text().length > 0) {
            var title = $("#layouHeader").attr("title")
            title = title + " שלב " + wiz_num.text() + " - " + wiz_text.text();
            $("#layouHeader").attr("title", title);
        }
        else {
            $("#layouHeader").attr("title", "עיריית תל אביב - רישום גני ילדים וחינוך יסודי");
        }
    }

   
}